import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ApplyBulkWorkforceGroupShiftGapRateOverridesMutationCgResponse,
  ApplyBulkWorkforceGroupShiftGapRateOverridesMutationVariables,
} from '@common/graphql/schema';

// The bulk-apply mutation surfaces all failures as GraphQL execution errors
// (see `ApplyBulkWorkforceGroupShiftGapRateOverrides` resolver), so callers do
// not need to read a top-level `errors` field — they branch on `errors` from
// the Apollo response instead.
export const APPLY_BULK_WORKFORCE_GROUP_SHIFT_GAP_RATE_OVERRIDES_MUTATION: TypedDocumentNode<
  ApplyBulkWorkforceGroupShiftGapRateOverridesMutationCgResponse,
  ApplyBulkWorkforceGroupShiftGapRateOverridesMutationVariables
> = gql`
  mutation ApplyBulkWorkforceGroupShiftGapRateOverrides(
    $shiftGapIds: [ID!]!
    $overrides: [WorkforceGroupRateOverrideInput!]!
  ) {
    applyBulkWorkforceGroupShiftGapRateOverrides(
      shiftGapIds: $shiftGapIds
      overrides: $overrides
    ) {
      shiftGaps {
        id
      }
    }
  }
`;
